
import { Play } from "lucide-react";

const tutorials = [
  {
    title: "Create Your Custom Assistant",
    description: "Learn how to create and customize your own AI assistant with Maia to handle your specific email needs.",
    url: "https://www.youtube.com/watch?v=830wHSurY-o"
  },
  {
    title: "Answer Multiple Emails",
    description: "Discover how to efficiently process and respond to multiple emails simultaneously using Maia.",
    url: "https://www.youtube.com/watch?v=EmIMv5M4yIc"
  },
  {
    title: "Regenerate with Comments",
    description: "See how to refine and regenerate email responses by adding your comments and feedback.",
    url: "https://www.youtube.com/watch?v=695iw0x2D1o"
  }
];

export const TutorialVideosSection = () => {
  return (
    <section id="tutorials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">Learn How to Use Maia</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {tutorials.map((tutorial, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
              <div className="relative aspect-video bg-gray-900">
                <iframe
                  className="w-full h-full absolute inset-0 z-10"
                  src={tutorial.url.replace('watch?v=', 'embed/')}
                  title={tutorial.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <div className="absolute inset-0 z-0 flex items-center justify-center bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                  <Play className="w-16 h-16 text-white" />
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{tutorial.title}</h3>
                <p className="text-gray-600">{tutorial.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
